import StemCraftLanding from './ExternalContests/StemCraftLanding/StemCraftLanding';
import PlethoraLanding from './ExternalContests/PlethoraLanding/PlethoraLanding';

export const externalContestsRegistry = {
  'stem-craft': StemCraftLanding,
  'plethora': PlethoraLanding,
};
